import { Box } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Pagination } from '@evocolabs/orkaui'

import { BlogCard, BlogCardProps } from './BlogCard'
import style from '@/pages/scss/HearingBlog.module.scss'

interface BlogListProps {
  dataProvider: Record<string, any>[]
  buttonMap: { key: string; text: string }[]
  count: number
}

export default React.forwardRef(function BlogList(
  { dataProvider = [], buttonMap, count = 6 }: BlogListProps,
  ref
) {
  const [start, setStart] = useState(0)
  const [type, setType] = useState(buttonMap[0].key)
  const [list, setList] = useState(dataProvider)
  const [page, setPage] = useState(1)
  const [isInit, setIsInit] = useState(false)

  const update = (value) => {
    if (value === buttonMap[0].key) {
      const res = dataProvider
      setList(res)
      return
    }
    setList(dataProvider.filter((item) => item.theme === value))
  }

  const toggleType = (value) => {
    if (value === type) return
    setType(value)
    setPage(1)
    setStart(0)
  }

  const paginationChange = (_, page) => {
    setPage(page)
    setStart((page - 1) * count)
  }

  useEffect(() => {
    update(type)
    setIsInit(true)
  }, [type, start])

  useEffect(() => {
    if (!isInit) return
    const box = document.querySelector('.blog-list-container-box')
    box.scrollIntoView()
    const headerHeight = document.querySelector('header')?.clientHeight || 0
    const titleHeight =
      document.querySelector('.blog-list-toggle-group')?.clientHeight || 0
    window.scrollBy(
      0,
      box.getBoundingClientRect().top - headerHeight - titleHeight
    )
  }, [list, page])

  React.useImperativeHandle(ref, () => ({
    toggleType
  }))

  return (
    <Box
      width="100%"
      flex="1"
      sx={{
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      <Box className={style['iframe']}>
        {list.slice(start, start + count).map((item) => (
          <div className={style['card']} key={item.id}>
            <BlogCard item={item as BlogCardProps} />
          </div>
        ))}
      </Box>
      <Pagination
        sx={{
          '&': {
            display: 'flex',
            justifyContent: 'center'
          },
          '& button': {
            backgroundColor: 'transparent',
            '&:hover': {
              backgroundColor: '#eff1f5',
              borderRadius: '4px'
            }
          }
        }}
        page={page}
        count={Math.ceil(list?.length / count) || 0}
        onChange={paginationChange}
      />
    </Box>
  )
})
